import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { AppComponent } from '../../app.component';
import { MessagesService } from '@core/_services/messages.service';
import {
    AvailableLoadMax,
    defLoadMax,
    defTokenDuration,
    defTitleCustMenu,
    defBackGround,
    defLogo,
    defBskColorMail,
    defBskColorCollect,
    defBskColorPublish,
    defBskColorAction,
    defBskColorInput,
    defBskColorOutput,
    defBskColorSystem,
    BskColorType,
    defaultModeViewDoc,
    actPdfModeViewDoc,
    imgModeViewDoc,
    defaultListActionDate,
    ActionDate,
    EmailCtrl, ext_Custom,
    defaultPage
} from '@documalis/_const/const';
import { PreferData, storeData, setUpdatePref, isEmpty, setOneColor, setBskColor, convertStringToBoolean, getInternalPrefUsr, isInArrayKey, ExecRegExp, getPageFromType } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { ConfirmationService } from 'primeng/api';
import { CheckTools } from '@service/check.tools';
import { RequestTools } from '@service/request.tools';
import { FileUpload } from 'primeng/fileupload';
import { TranslateService } from '@ngx-translate/core';
import { addRequestParam, getLabelOfTypePref, getPageList, setInformations, setPref, updateRequestParam } from '@core/_utils/param-screen-utils';
import { dateFormat, getComputedDate } from '@core/_utils/date.utils';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'page-param',
    templateUrl: './page-param.component.html',
    styleUrls: ['./page-param.component.scss'],
})
export class PageParamComponent implements OnInit {
    public fr: any;
    public requests = [];
    public availablePageList: any[];
    public availableLoadMax: any[];
    public availableModeViewDoc: any[];
    public availableListActionDate: any[];        
    public listActionDate = [];
    public availableToastDuration = [];
    public availableSmtpEncryption: any[];
    public selectedPage = '';
    public browseLabel = '';
    public fileMsg = '';
    public itemConfirm: ItemConfirmComponent;

    public screen: PreferData;
    public loadMax: PreferData;
    public tokenDuration: PreferData;
    public titleCustMenu: PreferData;
    public prefAccess: PreferData;
    public bskColorMail: PreferData;
    public bskColorCollect: PreferData;
    public bskColorPublish: PreferData;
    public bskColorAction: PreferData;    
    public bskColorInput: PreferData;
    public bskColorOutput: PreferData;
    public bskColorSystem: PreferData;    
    public prefAccessBool: boolean;
    public modeViewDoc: PreferData;    
    public defaultFullTextDate: PreferData;       
    public activNotif: PreferData;
    public discntAzure: PreferData;
    public activNotifBool: boolean;
    public discntAzureBool: boolean;
    public toastDurationValue: PreferData;
    public displayConfirm: PreferData;
    public displayConfirmBool: boolean;
    public requestOrder: PreferData;
    public requestOrderBool: boolean;
    public bskDockReorder: PreferData;
    public bskDockReorderBool: boolean;
    public srcDockReorder: PreferData;
    public srcDockReorderBool: boolean;

    public smtpHost: PreferData;
    public smtpPort: PreferData;
    public smtpUser: PreferData;
    public smtpPass: PreferData;
    public smtpFrom: PreferData;
    public smtpAuth: PreferData;
    public smtpAuthBool: boolean;
    public smtpEncryption: PreferData;
    public version: string = '';
    private tokenDurationValue: any;
    private internalPrefUsr: any;
    private titleCustMenuValue: any;
    private defaultFullTextDateSvg: any;

    public extList= ext_Custom;
    public selectedExt: PreferData;

    constructor(
        public menu: MenuServiceInt,
        public main: AppComponent,
        protected _messageService: MessagesService,
        private commonService: CommonService,
        public confirmationService: ConfirmationService,
        private checkTools: CheckTools,
        private requestTools: RequestTools,
        private translate: TranslateService,
        private api: ApiV6Service
    ) {
        this.menu.display = true;
        this.availablePageList = [];
        this.availableLoadMax = [];
        this.availableModeViewDoc = [];
        this.availableListActionDate = [];
        this.internalPrefUsr = {};
        this.browseLabel = this.translate.instant('Img_Sel');
        this.fileMsg = this.translate.instant('FileType_KO');
        this.availableToastDuration = [];        
        this.availableSmtpEncryption = [];
    }

    ngOnInit() {
        this.initializeValDef();
        this.execGetPref(true);
        this.setDefPref();
        this.commonService.checkReset();
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
    }

    public ngOnDestroy() {}

    private async execGetPref(aLoad) {
        let wRes;
        wRes = false;
        this.screen = setPref(0, defaultPage);
        this.prefAccess = setPref(0, 'true');
        this.loadMax = setPref(0, defLoadMax);
        this.tokenDuration = setPref(0, defTokenDuration);
        this.titleCustMenu = setPref(0, defTitleCustMenu);
        this.bskColorMail = setPref(0, defBskColorMail);
        this.bskColorCollect = setPref(0, defBskColorCollect);;
        this.bskColorPublish = setPref(0, defBskColorPublish);
        this.bskColorAction = setPref(0, defBskColorAction);
        this.bskColorInput = setPref(0, defBskColorInput);
        this.bskColorOutput = setPref(0, defBskColorOutput);
        this.bskColorSystem = setPref(0, defBskColorSystem);
        this.prefAccessBool = convertStringToBoolean(this.prefAccess.datapref);                
        this.modeViewDoc = setPref(0, defaultModeViewDoc);
        this.defaultFullTextDate = setPref(0, this.defaultFullTextDate);
        this.activNotif = setPref(0, 'false');
        this.activNotifBool = convertStringToBoolean(this.activNotif.datapref);    
        this.discntAzure = setPref(0, 'false');
        this.discntAzureBool = convertStringToBoolean(this.discntAzure.datapref);     
        this.toastDurationValue = setPref(0, 0);   
        this.displayConfirm = setPref(0, 'false');
        this.displayConfirmBool = convertStringToBoolean(this.displayConfirm.datapref);   
        this.requestOrder = setPref(0, 'true');
        this.requestOrderBool = convertStringToBoolean(this.requestOrder.datapref);  
        this.bskDockReorder = setPref(0, 'false');
        this.bskDockReorderBool = convertStringToBoolean(this.bskDockReorder.datapref);
        this.srcDockReorder = setPref(0, 'false');
        this.srcDockReorderBool = convertStringToBoolean(this.srcDockReorder.datapref);

        this.smtpHost = setPref(0,'');
        this.smtpPort = setPref(0,0);
        this.smtpUser = setPref(0,'');
        this.smtpPass = setPref(0,'');
        this.smtpFrom = setPref(0,'');
        this.smtpAuth = setPref(0, 'true');
        this.smtpEncryption = setPref(0, 'TLS');
        this.smtpAuthBool = convertStringToBoolean(this.smtpAuth.datapref);

        this.selectedExt = setPref(0, '')

        wRes = await this.requestTools.getUserPrefer();
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return;
        }
        wRes.data.getUserPref.data.map((item) => {
            this.affectValue(item);
        });           
        this.version = setInformations(wRes.data.getInformations);
    }

    private setDefPref() {
        let wIndate: any;
        wIndate = {
            label: dateFormat(getComputedDate('TNow'), 'dd/MM/yyyy'),
            value: 'TInDate',
        };
        this.availablePageList = getPageList(this.translate);
        this.listActionDate.unshift(wIndate);
        this.availableLoadMax = AvailableLoadMax;   
        this.prefAccessBool = true;        
        this.availableModeViewDoc.push({ label: this.translate.instant('Read_Pdf'), value: defaultModeViewDoc });
        this.availableModeViewDoc.push({ label: this.translate.instant('Act_Pdf'), value: actPdfModeViewDoc });
        this.availableModeViewDoc.push({ label: this.translate.instant('Pic'), value: imgModeViewDoc });
        this.availableListActionDate = [...this.listActionDate];
        this.activNotifBool = false;
        this.discntAzureBool = false;
        this.displayConfirmBool = true;
        this.requestOrderBool = false;
        this.bskDockReorderBool = false
        this.srcDockReorderBool = false
        this.availableToastDuration.push({ label: this.translate.instant('ToastDuration0'), value: '0' });
        this.availableToastDuration.push({ label: this.translate.instant('ToastDuration1'), value: '5000' });
        this.availableToastDuration.push({ label: this.translate.instant('ToastDuration2'), value: '10000' });
        this.availableToastDuration.push({ label: this.translate.instant('ToastDuration3'), value: '20000' });
        this.availableSmtpEncryption.push({ label: this.translate.instant('SMTPEncryptionTls'), value: 'TLS' });
        this.availableSmtpEncryption.push({ label: this.translate.instant('SMTPEncryptionSSL'), value: 'SSL' });
    }

    // Initialisation du tableau avec toutes les valeurs par défaut
    // Attention : modifier la partie server
    //  0 : Ecran par défaut
    //  1 : Thème des composants
    //  2 : Cacher le bannettes vides
    //  3 : Thème du menu
    //  4 : Style du menu
    //  5 : Gradient des bannettes
    //  6 : Afficher nombre de document intégrés
    //  7 : Style du diagramme
    //  8 : Période stat intégration
    //  9 : Bannettes chargées à afficher
    //  10 à 19 pour le dashboard
    //  20 : Document suivant après validation
    //  21 : Thème de la bannière
    //  22 : Taille de l'affichage
    //  23 : Taille maxi envoi fichier
    //  24 : Nombre de requêtes à afficher
    //  25 : Durée du token
    //  26 : Mode de visualisation
    //  27 : Accès aux préférences
    //  28 : Titre menu écrans personnalisés
    //  29 : Afficher les anciens documents
    //  30 : Afficher les dernières requêtes
    //  31 : Afficher les bannettes chargées
    //  32 : Afficher les documents consultés
    //  33 : Afficher les documents traités
    //  34 : Sélection image de fond
    //  35 : Sélection logo
    //  36 : Couleur bannette mail
    //  37 : Couleur bannette collect
    //  38 : Couleur bannette publish
    //  39 : Couleur bannette action
    //  40 : Couleur bannette input
    //  41 : Couleur bannette output
    //  42 : Couleur bannette system
    //  43 : Mode visu document
    //  44 : Date par défaut recherche plein texte
    //  45 : Type d'affichage des input primeng
    //  46 : Activation mentions
    //  47 : Recalcul des positions des docks
    //  48 : SMTP host
    //  49 : SMTP port
    //  50 : SMTP user
    //  51 : SMTP pass
    //  52 : SMTP from
    //  53 : SMTP auth
    //  54 : Mode basket compact
    //  55 : Extensions bannettes
    //  56 : Déconnexion azure
    //  57 : Durée toast
    //  58 : Afficher les fenêtres de confirmation
    //  59 : Afficher les recherches par type
    //  60 : SMTP encryption
    //  61 : Visualisation mode détail bannette
    //  62 : Visualisation mode détail recherche
    //  63 : Réorganisation des docks des bannettes
    //  64 : Réorganisation des docks des recherches
    //  65 : Ecran par défaut général

    private initializeValDef() {
        addRequestParam(this.requests, this.translate.instant('Pref_23'), defLoadMax, 0, 23);
        addRequestParam(this.requests, this.translate.instant('Pref_25'), defTokenDuration, 0, 25);
        addRequestParam(this.requests, this.translate.instant('Pref_27'), 'true', 0, 27);
        addRequestParam(this.requests, this.translate.instant('Pref_28'), defTitleCustMenu, 0, 28);
        addRequestParam(this.requests, this.translate.instant('Pref_34'), defBackGround, 0, 34);
        addRequestParam(this.requests, this.translate.instant('Pref_35'), defLogo, 0, 35);
        addRequestParam(this.requests, this.translate.instant('Pref_36'), defBskColorMail, 0, 36);
        addRequestParam(this.requests, this.translate.instant('Pref_37'), defBskColorCollect, 0, 37);
        addRequestParam(this.requests, this.translate.instant('Pref_38'), defBskColorPublish, 0, 38);
        addRequestParam(this.requests, this.translate.instant('Pref_39'), defBskColorAction, 0, 39);
        addRequestParam(this.requests, this.translate.instant('Pref_40'), defBskColorInput, 0, 40);
        addRequestParam(this.requests, this.translate.instant('Pref_41'), defBskColorOutput, 0, 41);
        addRequestParam(this.requests, this.translate.instant('Pref_42'), defBskColorSystem, 0, 42);
        addRequestParam(this.requests, this.translate.instant('Pref_43'), defaultModeViewDoc, 0, 43);
        addRequestParam(this.requests, this.translate.instant('Pref_44'), defaultListActionDate, 0, 44);        
        addRequestParam(this.requests, this.translate.instant('Pref_46'), false, 0, 46);             
        addRequestParam(this.requests, this.translate.instant('Pref_47'), false, 0, 47);
        addRequestParam(this.requests, this.translate.instant('Pref_48'), '', 0, 48);
        addRequestParam(this.requests, this.translate.instant('Pref_49'), '', 0, 49);
        addRequestParam(this.requests, this.translate.instant('Pref_50'), '', 0, 50);
        addRequestParam(this.requests, this.translate.instant('Pref_51'), '', 0, 51);        
        addRequestParam(this.requests, this.translate.instant('Pref_52'), '', 0, 52);        
        addRequestParam(this.requests, this.translate.instant('Pref_53'), '', 0, 53);
        addRequestParam(this.requests, this.translate.instant('Pref_55'), ext_Custom, 0, 55);
        addRequestParam(this.requests, this.translate.instant('Pref_56'), false, 0, 56);  
        addRequestParam(this.requests, this.translate.instant('Pref_57'), '0', 0, 57);
        addRequestParam(this.requests, this.translate.instant('Pref_58'), true, 0, 58);                  
        addRequestParam(this.requests, this.translate.instant('Pref_59'), false, 0, 59);                          
        addRequestParam(this.requests, this.translate.instant('Pref_60'), 'TLS', 0, 60);       
        addRequestParam(this.requests, this.translate.instant('Pref_63'), false, 0, 63);                          
        addRequestParam(this.requests, this.translate.instant('Pref_64'), false, 0, 64);     
        addRequestParam(this.requests, this.translate.instant('Pref_0'), defaultPage, 0, 65);
        ActionDate.forEach(item => {
            switch (item.value) {
                case 'TNoDate':
                case 'TNow':
                case 'TYesterday':
                case 'TBeforeYesterday':
                case 'TLastWeek':        
                case 'TBeginMonth':
                case 'TBeginPrevMonth':
                case 'TEndPrevMonth':
                case 'TBeginYear':
                case 'TBeginPrevYear':
                case 'TEndPrevYear': {
                    this.listActionDate.push({ label: this.translate.instant(item.value), value: item.value});            
                }
            }
        })
    }
   
    public initialize() {
        let wRequestList = [];
        let wRequestData: {};        
        let wIntern: any;
        let wColorList = [];
        this.requests = [];
        this.initializeValDef();
        this.requests.forEach((item) => {
            wRequestData = {
                requestData: setUpdatePref(item.id, item.typepref, item.datapref)
            };
            wRequestList.push(wRequestData);       
        });
        wRequestData = {
            updatelist: wRequestList,
        };
        this.update(wRequestData, true);

        wColorList[BskColorType[1]] = defBskColorCollect;
        wColorList[BskColorType[0]] = defBskColorMail;
        wColorList[BskColorType[2]] = defBskColorPublish;
        wColorList[BskColorType[3]] = defBskColorAction; 
        wColorList[BskColorType[4]] = defBskColorInput;
        wColorList[BskColorType[5]] = defBskColorOutput;
        wColorList[BskColorType[6]] = defBskColorSystem;

        wIntern = JSON.parse(atob(localStorage.getItem('intern')));
        setBskColor(wColorList);
        BskColorType.map(item => {
            wIntern[item] = wColorList[item];
        })
        storeData('intern', btoa(JSON.stringify(wIntern)));
    }

    // Maj des valeurs
    // Attention : valeurs utilisées : de 10 à 19 pour le dashboard
    private affectValue(aItem) {
        switch (aItem.typepref) {
            case 23: {
                this.loadMax = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
                wInternal.maxload = aItem.datapref;
                storeData('intern', btoa(JSON.stringify(wInternal)));
                break;
            }
            case 25: {
                this.tokenDuration = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.tokenDurationValue = this.tokenDuration.datapref;
                break;                
            }
            case 27: {
                this.prefAccess = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.prefAccessBool = convertStringToBoolean(this.prefAccess.datapref);
                break;
            }            
            case 28: {
                this.titleCustMenu = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.titleCustMenuValue = this.titleCustMenu.datapref;
                let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
                wInternal.titleCust = aItem.datapref;
                storeData('intern', btoa(JSON.stringify(wInternal)));
                break;                     
            }
            case 36: {
                this.bskColorMail = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 37: {
                this.bskColorCollect = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 38: {
                this.bskColorPublish = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 39: {
                this.bskColorAction = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 40: {
                this.bskColorInput = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 41: {
                this.bskColorOutput = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 42: {
                this.bskColorSystem = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 43: {
                this.modeViewDoc = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr = getInternalPrefUsr();
                this.internalPrefUsr.modeViewDoc = aItem.datapref;
                break;                
            }
            case 44: {
                this.defaultFullTextDate = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr = getInternalPrefUsr();
                this.internalPrefUsr.defaultFullTextDate = aItem.datapref;
                this.defaultFullTextDateSvg = this.internalPrefUsr.defaultFullTextDate;
                break;                
            }
            case 46: {
                this.activNotif = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.activNotifBool = convertStringToBoolean(this.activNotif.datapref);
                break;
            }
            case 48: {
                this.smtpHost = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 49: {
                this.smtpPort = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 50: {
                this.smtpUser = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 51: {
                this.smtpPass = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 52: {
                this.smtpFrom = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }            
            case 53: {
                this.smtpAuth = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.smtpAuthBool = convertStringToBoolean(this.smtpAuth.datapref);
                break;
            }
            case 54: {
                this.smtpAuth = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 55: {
                this.selectedExt = updateRequestParam(this.requests, JSON.parse(aItem.datapref), aItem.id, aItem.typepref);
                break;
            }
            case 56: {
                this.discntAzure = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.discntAzureBool = convertStringToBoolean(this.discntAzure.datapref);
                break;
            }
            case 57: {
                this.toastDurationValue = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);                
                let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
                wInternal.toastDurationValue = aItem.datapref;
                storeData('intern', btoa(JSON.stringify(wInternal)));
                this._messageService.setToastDuration(aItem.datapref);
                break;
            }
            case 58: {
                this.displayConfirm = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.displayConfirmBool = convertStringToBoolean(this.displayConfirm.datapref);
                break;
            }
            case 59: {
                this.requestOrder = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.requestOrderBool = convertStringToBoolean(this.requestOrder.datapref);
                break;
            }
            case 60: {
                this.smtpEncryption = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            } 
            case 63: {
                this.bskDockReorder = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.bskDockReorderBool = convertStringToBoolean(this.bskDockReorder.datapref);
                break;
            }            
            case 64: {
                this.srcDockReorder = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.srcDockReorderBool = convertStringToBoolean(this.srcDockReorder.datapref);
                break;
            }              
            case 65: {
                this.screen = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.defaultPage = getPageFromType(this.screen.datapref);
                break;
            }
        }
    }

    public getLabelOfTypePref(aTypePref) {
        return getLabelOfTypePref(aTypePref, this.requests);
    }
   
    public onChangeValue($event) {
        this.saveValue($event);
    }

    public onChangeValueDate($event) {
        let wRes: any;
        wRes = this.verifyDateValue(this.defaultFullTextDate.datapref);
        if (wRes.res === false) {
            this._messageService.addErrorNoStick(this.translate.instant('DateFullText_KO'));
        } else {
            this.saveValue(44);
        }
    }    

    private verifyDateValue(aDate) {
        let wDate = '';
        let wTest = '';
        let wRes: any = {};
        if (!isInArrayKey(aDate, this.listActionDate, 'value')
        ) {
            let wtest = aDate.split('/');
            wtest = wtest.reverse();
            wDate = wtest[0] + '-' + wtest[1] + '-' + wtest[2];
            let wDt = new Date(wDate);
            
            wTest = dateFormat(wDt, 'yyyy-MM-dd');
            if (wTest === 'Date invalide') {
                wRes.res = false;
                wRes.value = wTest;
            } else {
                wRes.res = true;
                wRes.value = wTest;
            }
        } else {
            wRes.res = true;
            wRes.value = aDate;
        }
        return wRes;
    }

    public onChangeValueColor($event, $aType, $aValue) {
        let wIntern: any;
        this.saveValue($event);

        wIntern = JSON.parse(atob(localStorage.getItem('intern')));
        setOneColor($aType, $aValue);
        wIntern[$aType] = $aValue;
        storeData('intern', btoa(JSON.stringify(wIntern)));
    }

    public onUpload(event) {
        this._messageService.addInfo(this.translate.instant('File_Send_1'));
    }

    public onClickUpload(aUploader: FileUpload, aAction) {
        if (aUploader.files.length === 0) {
            this._messageService.addWarnNoStick(this.translate.instant('NoFile_Sel'));
        } else {
            aUploader.url = this.requestTools.setFile(aAction);
            aUploader.upload();
        }
    }

    public removeItem(file: File, uploader: FileUpload) {
        const index = uploader.files.indexOf(file);
        uploader.remove(null, index);
    }

    public onUploadLogo(event) {
        this._messageService.addInfo(this.translate.instant('File_Send_1'));
    }

    public onChangeValueCustTitle() {
        if (isEmpty(this.titleCustMenu.datapref)) {
            this._messageService.addWarn(this.translate.instant('Menu_KO_2'));
        } else {
            this.saveValue(28);
        }
    }

    public onBlurToken($event) {        
        if ($event.currentTarget.ariaValueNow != this.tokenDurationValue) {
            if (!$event.relatedTarget) {
                this._messageService.addWarn(this.translate.instant('Token_KO_3'));
                return;
            }
            if ($event.relatedTarget.id !== 'saveToken') {
                this._messageService.addWarn(this.translate.instant('Token_KO_3'));
                return;
            }   
        }      
    }
    
    public onBlurTitleMenu($event) {        
        if ($event.currentTarget.value != this.titleCustMenuValue) {
            if (!$event.relatedTarget) {
                this._messageService.addWarn(this.translate.instant('Token_KO_3'));
                return;
            }
            if ($event.relatedTarget.id !== 'saveTitle') {
                this._messageService.addWarn(this.translate.instant('Token_KO_3'));
                return;
            }   
        }      
    }

    public saveValue(aValue) {
        this.update(this.prepareRequestData(aValue), false);
    }
    
    public onSaveSmtp($event) {
        if (this.smtpFrom.datapref.trim() !== '') {
            if (!ExecRegExp(EmailCtrl, '', this.smtpFrom.datapref)) {
                this._messageService.addErrorMsg(this.translate.instant('Cf_WrongMail'));
                return;
            }
        }
        if ($event === true) {
            this.execSaveSmtp();
        } else {
            this.execTestSmtp();
        }
    }

    private async execSaveSmtp() {
        let wRes;
        const wData = {
            smtpHost: this.smtpHost.datapref,
            smtpPort: this.smtpPort.datapref,
            smtpUser: this.smtpUser.datapref,
            smtpPass: this.smtpPass.datapref,
            smtpFrom: this.smtpFrom.datapref,
            smtpAuth: this.smtpAuthBool.toString(),
            smtpEncryption: this.smtpEncryption.datapref
        };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updateprefsmtp', wData));
            this._messageService.addInfo(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        } 
    }

    private async execTestSmtp() {
        let wRes;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('testsmtp', ''));
            this._messageService.addInfo(this.translate.instant('Send_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Send_KO'));
        } 
    }

    public onCompDock() {
        this.itemConfirm.confirmAction(
            'compdock',
            this.translate.instant('Confirm_Param_D'),
            () => {
                this.compDocks();
            }
        );
    }

    public async compDocks() {
        let wRes;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('compdocks', ''));
            this._messageService.addInfo(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }        
    }

    private async update(aData, aInitialize) {
        let wRes;
        wRes = false;
        const wData = {
            requestData: aData,
            initialize: aInitialize,
        };
        wRes = await this.requestTools.setUserPref(wData);
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        this._messageService.addInfo(this.translate.instant('Update_OK'));
        if (aInitialize === false) {
            this.affectValue(wRes.data.data.requestData);
            storeData('internalprefusr', btoa(JSON.stringify(this.internalPrefUsr)));
        } else {
            await this.execGetPref(false);
        }
    }
    
    // Attention : valeurs utilisées : de 10 à 19 pour le dashboard

    private prepareRequestData(aType) {
        let requestData: {};
        var fn;
        const type = {
            23: [this.loadMax.id, 23, this.loadMax.datapref],
            25: [this.tokenDuration.id, 25, this.tokenDuration.datapref],
            27: [this.prefAccess.id, 27, this.prefAccessBool.toString()],            
            28: [this.titleCustMenu.id, 28, this.titleCustMenu.datapref],
            36: [this.bskColorMail.id, 36, this.bskColorMail.datapref],
            37: [this.bskColorCollect.id, 37, this.bskColorCollect.datapref],
            38: [this.bskColorPublish.id, 38, this.bskColorPublish.datapref],
            39: [this.bskColorAction.id, 39, this.bskColorAction.datapref],
            40: [this.bskColorInput.id, 40, this.bskColorInput.datapref],
            41: [this.bskColorOutput.id, 41, this.bskColorOutput.datapref],
            42: [this.bskColorSystem.id, 42, this.bskColorSystem.datapref],
            43: [this.modeViewDoc.id, 43, this.modeViewDoc.datapref],
            44: [this.defaultFullTextDate.id, 44, this.defaultFullTextDate.datapref],            
            46: [this.activNotif.id, 46, this.activNotifBool.toString()],
            55: [this.selectedExt.id, 55, JSON.stringify(this.selectedExt.datapref)],
            56: [this.discntAzure.id, 56, this.discntAzureBool.toString()],
            57: [this.toastDurationValue.id, 57, this.toastDurationValue.datapref],
            58: [this.displayConfirm.id, 58, this.displayConfirmBool.toString()],
            59: [this.requestOrder.id, 59, this.requestOrderBool.toString()],
            63: [this.bskDockReorder.id, 63, this.bskDockReorderBool.toString()],
            64: [this.srcDockReorder.id, 64, this.srcDockReorderBool.toString()],                        
            65: [this.screen.id, 65, this.screen.datapref],
        }
        if (type[aType]) {
            fn = type[aType];
            return requestData = setUpdatePref(fn[0], fn[1], fn[2]);
        }
    }
}
